/**
 * Standalone Designer Page
 * 
 * Full-page agent workflow designer for creating and managing presets.
 * Uses the shared AgentDesigner component.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import Header from '../../components/Header';
import ErrorBoundary from '../../components/ErrorBoundary';
import { AgentDesigner } from '../../components/designer';
import './Designer.css';

export function DesignerPage() {
    const navigate = useNavigate();
    const { theme, setTheme } = useTheme();

    // Handle navigation back to dashboard
    const handleBackToDashboard = () => {
        navigate('/dashboard');
    };

    // Handle mode change - in standalone, just navigate
    const handleModeChange = (mode) => {
        if (mode === 'builder') {
            navigate('/dashboard');
        }
        // Already on designer, no action needed
    };

    return (
        <div className="designer-page" data-theme={theme}>
            <Header
                activeMode="agent-designer"
                onModeChange={handleModeChange}
                showLeftRibbon={true}
                showBackButton={true}
                onBackToDashboard={handleBackToDashboard}
                pageTitle="Agent Designer"
                theme={theme}
                onThemeChange={setTheme}
                chatSidebarOpen={false}
                onToggleChatSidebar={() => {}}
                minimalMode={true}
            />
            
            <ErrorBoundary name="Agent Designer">
                <AgentDesigner 
                    standalone={true}
                    visible={true}
                />
            </ErrorBoundary>
        </div>
    );
}

export default DesignerPage;

